import SipConnPage from "@/components/SipConnPage";

export default function CustomerVendors() {
  return (
    <SipConnPage
      title="Vendors Routing"
      subtitle="Outbound vendor routes — IP-to-IP or SIP registration"
      apiBase="/customer-routing/vendors"
      testid="vendors"
      entityLabel="vendor"
      showCodecs
      showAssignedInfra
    />
  );
}
